// Entornos de pruebas: se detectan por el dominio para usar el mismo build en dev y prod
const TEST_HOSTNAMES = ['dev.clubparticipa.com', 'localhost', '127.0.0.1'];

export const IS_TEST_ENVIRONMENT = TEST_HOSTNAMES.includes(window.location.hostname);
export const TEST_ENVIRONMENT_LABEL = 'PRUEBAS';
export const TEST_ENVIRONMENT_COLOR = '#F57C00';

// Marca la pestaña del navegador (título y favicon) para distinguirla de producción
export const applyTestEnvironmentMarks = (): void => {
  if (!IS_TEST_ENVIRONMENT) return;

  document.body.classList.add('test-environment');
  document.title = `[${TEST_ENVIRONMENT_LABEL}] ${document.title}`;

  const favicon = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if (!favicon) return;

  const img = new Image();
  img.onload = () => {
    const size = 64;
    const canvas = document.createElement('canvas');
    canvas.width = size;
    canvas.height = size;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    ctx.drawImage(img, 0, 0, size, size);
    ctx.beginPath();
    ctx.arc(size * 0.72, size * 0.72, size * 0.26, 0, 2 * Math.PI);
    ctx.fillStyle = TEST_ENVIRONMENT_COLOR;
    ctx.fill();
    ctx.lineWidth = size * 0.06;
    ctx.strokeStyle = '#FFFFFF';
    ctx.stroke();
    favicon.href = canvas.toDataURL('image/png');
  };
  img.src = favicon.href;
};
